export enum AlarmPathIdTypes {
    INPUT = 'input',
    TEMPERATURE = 'temp',
    HUMIDITY = 'humidity',
    ANALOG = 'analog'
}

export enum AlarmTypes {
    INPUT = 'AlarmInput',
    TEMPERATURE = 'AlarmTemp',
    HUMIDITY = 'AlarmHum',
    ANALOG = 'AlarmVoltage'
}